import { useTranslation } from "react-i18next";
import { FileText, Plus, EyeOff, TrendingUp } from "lucide-react";

interface ContentStatsProps {
  total: number;
  todayNew: number;
  hidden: number;
  activeRate: number;
  loading?: boolean;
}

export function ContentStats({ total, todayNew, hidden, activeRate, loading }: ContentStatsProps) {
  const { t } = useTranslation();
  const values = { total, todayNew, hidden, activeRate };

  const stats = [
    { key: 'total', label: t('admin.content.stats.totalScripts'), icon: FileText, color: 'bg-[#FFD93D]' },
    { key: 'todayNew', label: t('admin.content.stats.todayNew'), icon: Plus, color: 'bg-[#6FEDD6]' },
    { key: 'hidden', label: t('admin.content.stats.hidden'), icon: EyeOff, color: 'bg-[#FF6B9D]' },
    { key: 'activeRate', label: t('admin.content.stats.activeRate'), icon: TrendingUp, color: 'bg-[#4DA6FF]', suffix: '%' },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {stats.map((stat) => (
        <div
          key={stat.key}
          className={`${stat.color} rounded-xl border-2 border-black p-6 shadow-[4px_4px_0_#1A1A1A] transition-all hover:translate-x-0.5 hover:translate-y-0.5 hover:shadow-[2px_2px_0_#1A1A1A] active:translate-x-1 active:translate-y-1 active:shadow-none`}
        >
          <div className="flex items-center justify-between mb-4">
            <span className="text-xs font-black uppercase tracking-wider opacity-60">
              {stat.label}
            </span>
            <stat.icon className="h-5 w-5 opacity-60" />
          </div>
          {loading ? (
            <div className="h-10 w-24 rounded bg-black/10 animate-pulse" />
          ) : (
            <p className="text-4xl font-black tracking-tight">
              {values[stat.key as keyof typeof values].toLocaleString()}{stat.suffix || ''}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}

